import type { SitePageSection } from "@/lib/site-pages-server";

/** Public URL for the games hub site page (`section === "games"`). */
export const GAMES_HUB_PATH = "/games";

/**
 * Public URL for a published site page.
 * Topic pages live at `/pages/[slug]`; the games hub stays at `/games`.
 */
export function getSitePagePublicPath(
  section: SitePageSection | string,
  slug: string | null
): string {
  if (section === "games") return GAMES_HUB_PATH;
  if (section === "topics" && slug) return `/pages/${slug}`;
  return "#";
}

/** Legacy topic URL at `/games/[slug]` (permanent redirect target is `/pages/[slug]`). */
export function getLegacyTopicGamesPath(slug: string): string {
  return `/games/${slug}`;
}
